// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Menu';

export function Hamburger({ className }: { className: string }) {
  return (
    <svg
      className={className}
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={TITLE}
      role="img"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 6H19V8H5V6ZM5 11H19V13H5V11ZM19 16H5V18H19V16Z"
        fill="currentColor"
      />
    </svg>
  );
}
